import Collection from '../Model/Collection';

import OrganizationSecurity from '../Admin/Screens/OrganizationSecurity';

export class OrganizationSecurity_Collection extends Collection {
    constructor(props, onSetState, onApiError, organizationId, onAlert) {
        if (typeof organizationId !== "string") {
            console.log("Warning: organizationId required and not found");
        }
        super(props, onSetState, onApiError, false, false);

        this.HideToolHeader = true;
        this.PassThroughComponent = (
            <OrganizationSecurity
                {...props}
                organizationId={organizationId}
                onApiError={onApiError}
                onAlert={onAlert}
            />
        );
    }
}
